import DataTable from "react-data-table-component";
// import { Spinner } from "components/spinner";

const customStyles = {
   // tableWrapper: {
   //    style: {
   //       overflowX: "visible",
   //       overflowY: "visible",
   //    },
   // },
   // table: {
   //    style: {
   //       position: "relative",
   //       overflowX: "visible",
   //       overflowY: "visible",
   //    },
   // },
   header: {
      style: {
         display: "none",
      },
   },
   subHeader: {
      style: {
         border: "none",
         boxShadow: "none",
      },
   },
   head: {
      style: {
         border: "none",
         boxShadow: "none",
      },
   },
   headRow: {
      style: {
         border: "none",
         gap: "3.5rem",
         // textAlign: "left",
      },
   },
   rows: {
      style: {
         fontSize: "14px",
         color: "#545F7D",
         textTransform: 'capitalize',
         padding: "2.3rem 0",
         minHeight: "initial",
         gap: "3.5rem",
      },
      selectedHighlightStyle: {
         "&:nth-of-type(n)": {
            backgroundColor: "#3577e51f",
         },
      },
   },
   headCells: {
      style: {
         fontWeight: "600",
         fontSize: "1.2rem",
         textTransform: "uppercase",
         color: "#545F7D",
         padding: 0,


         // "> div:nth-child(1)": {
         //    overflow: "visible",
         // },
      },
   },
   cells: {
      style: {
         wordBreak: 'break-word',
         padding: 0,

         "&:first-child": {
            padding: 0,

            "&:first-child": {
               whiteSpace: 'unset !important',
               textOverflow: 'unset !important',
            }


         },
      },
   },
};

export const Table = ({ isLoading, columns, data }) => {
   return (
      <DataTable
         progressPending={isLoading}
         // progressComponent={
         //    <div style={{ height: "200px", display: "flex", alignItems: "center" }}>
         //       <Spinner />
         //    </div>
         // }
         customStyles={customStyles}
         data={data}
         columns={columns}
         responsive
      />
   );
};
